import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import { useSelector } from 'react-redux';
import { updateMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import { AssessmentButtons } from '../shared';
import { ModalDialog } from '../../reusable';
import { WhatsTalkiatry } from '../../app/menu/whats-talkiatry';
import { WhatsPsychiatry } from '../../app/menu/whats-psychiatry';
import { IntroVideo } from './intro-video';
import { selectLdFlags } from '../../../redux/ld-flags';

const IntroScreenOne = () => {
  const dispatch = useAppDispatch();
  const { showIntroVideoInDialog } = useSelector(selectLdFlags);

  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  useEffect(() => {
    const measurement = performance.measure(
      'pageload__assessment__first_render',
      'pageload__assessment__rendering'
    );
    console.log({
      action: 'pageload__assessment__first_render',
      duration: measurement.duration,
      start_time: performance.getEntriesByName(
        'pageload__assessment__rendering'
      )?.[0].startTime,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      success: true,
    });

    const fullPageLoadMeasurement = performance.measure(
      'pageload__assessment',
      'pre-pageload'
    );
    console.log({
      action: 'pageload__assessment',
      duration: fullPageLoadMeasurement.duration,
      start_time: performance.getEntriesByName('pre-pageload')?.[0].startTime,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      success: true,
    });
    if (process.env.NEXT_PUBLIC_DD_ENV === 'prod') {
      performance.clearMarks('pageload__assessment__rendering');
      performance.clearMeasures('pageload__assessment__first_render');

      performance.clearMarks('pageload__assessment');
      performance.clearMeasures('pageload__assessment__first_render');
    }
  }, []);

  return (
    <>
      <Card sx={{ borderRadius: 2 }}>
        {!showIntroVideoInDialog && <IntroVideo roundedCorners />}
      </Card>
      <AssessmentButtons
        primary={{
          children: 'Start our short assessment',
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
      <ModalDialog title={"What's Talkiatry?"}>
        <WhatsTalkiatry color="primary.main" />
      </ModalDialog>
      <ModalDialog title="What's psychiatry?">
        <WhatsPsychiatry color="primary.main" />
      </ModalDialog>
    </>
  );
};

export default IntroScreenOne;
